import React from "react";

type StopSignIconProps = {
  size?: number;
  style?: React.CSSProperties;
};

const StopSignIcon = ({ size = 22, style }: StopSignIconProps) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    style={{ flexShrink: 0, ...style }}
  >
    <polygon
      points="7,1 17,1 23,7 23,17 17,23 7,23 1,17 1,7"
      fill="#c62828"
      stroke="#8e0000"
      strokeWidth="1"
    />
    <text
      x="12"
      y="14"
      textAnchor="middle"
      fontSize="5"
      fontWeight="700"
      fill="#ffffff"
      fontFamily="Arial, sans-serif"
    >
      STOP
    </text>
  </svg>
);

export default StopSignIcon;
